import { exposeStateOnWindow, logger } from '@element451-libs/utils451/ngrx';

export const metaReducers = [exposeStateOnWindow, logger];
